import React from 'react';
import { Root } from './style';

import { useState } from '@hookstate/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import vars from 'variables';

const ContractLinks = () => {
  const copied = useState(false);

  // const tokenSymbol = 'HODL';
  // const tokenDecimals = 18;
  // const tokenImage = `${vars.assetsPrefix}2e8ab7e5-9233-486f-aa25-1ab6f0c4d4e3`;
  const tokenAddress = (vars.links.contract.match(/[^\/]+$/) || [])[0];

  // TODO
  // const addToken = async () => {
  //   try {
  //     await window.ethereum.request({
  //       method: 'wallet_watchAsset',
  //       params: {
  //         type: 'BEP20',
  //         options: {
  //           address: tokenAddress,
  //           symbol: tokenSymbol,
  //           decimals: tokenDecimals,
  //           image: tokenImage,
  //         },
  //       },
  //     });
  //
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const onCopy = () => {
    copied.set(true);
    setTimeout(() => {
      copied.set(false);
    }, 1250);
  };

  return (
    <Root className="contract-links">
      <CopyToClipboard text={tokenAddress} onCopy={onCopy}>
        <div className={`address ${copied.get() ? 'copied' : ''}`}>
          {tokenAddress.slice(0, 5)}...{tokenAddress.slice(-5)}
        </div>
      </CopyToClipboard>
    </Root>
  );
};

export default ContractLinks;
